import React from "react";
import "./AmenityList.css";

const parseAmenities = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) {
    return raw
      .filter((item) => typeof item === "string")
      .map((item) => item.trim())
      .filter(Boolean);
  }
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed
          .filter((item) => typeof item === "string")
          .map((item) => item.trim())
          .filter(Boolean);
      }
    } catch {
      return raw
        .replace(/^\{/, "")
        .replace(/\}$/, "")
        .split(",")
        .map((item) => item.replace(/["']/g, "").trim())
        .filter(Boolean);
    }
  }
  return [];
};

const AmenityList = ({ amenities, variant = "inline" }) => {
  const items = parseAmenities(amenities);
  if (items.length === 0) return null;

  const wrapperClass = `amenity-list amenity-list--${variant}`;

  return (
    <div className={wrapperClass} role="list" aria-label="Cinema amenities">
      {items.map((amenity, index) => (
        <span
          key={`${amenity}-${index}`}
          className={`amenity-pill amenity-pill--${variant}`}
          role="listitem"
          title={amenity}
        >
          <i className="fas fa-check-circle" aria-hidden="true"></i>
          <span className="amenity-pill__label">{amenity}</span>
        </span>
      ))}
    </div>
  );
};

export default AmenityList;
export { parseAmenities };
